export const getJsonPretty = (formlyFields: any) => {
  let pretty: string = '';
  try {
    pretty = JSON.stringify(formlyFields, undefined, 3);
  } catch (error) {
    if (error instanceof Error) {
      try {
        pretty = JSON.stringify(formlyFields);
      } catch (error2) {
        if (error2 instanceof Error) {
          console.log("getJsonPretty: "+error2.message);
        }
      }
    }
  }
  return pretty;
};
